<template>
  <v-container>
    <v-card outlined tile>
      <div>
        <pre><code :class="className" :style="objStyle" v-html="highlightCode"></code></pre>
      </div>
    </v-card>
    <!-- </div> -->
  </v-container>
</template>

<style>
</style>
<script>
// import core from "highlight.js/lib/core.js";
import core from "highlight.js/lib/common";
core.registerLanguage("sas", require("highlight.js/lib/languages/sas"));

import "highlight.js/styles/monokai.css";

export default {
  name: "CodeViewer",
  data: () => ({
    strCode: "",
    strBackgroundColor: "#272822",
    strDetectLang: "sas",
    boolUnkonwLang: false,
    objStyle: {
      "font-size": "20px",
      color: "#ffffff",
      background: "#272822",
      "font-family": "Consolas",
      "text-align": "left"
    },
    objScript: {},
  }),
  props: {
    script: Object,
    boolClear: Boolean,
  },
  mounted() {
    this.objScript = Object.assign({}, this.script);
  },
  beforeDestroy() {
    // console.log("AAAAAAAAAAAAAAAAAAA");
  },
  watch: {
    boolClear(val) {
      // console.log(val);
      if (val) {
        this.objScript = {};
      }
    },
  },
  computed: {
    className() {
      if (this.boolUnkonwLang) return "";
      return "hljs " + this.strDetectLang;
    },
    highlightCode() {
      // console.log(this.script);
      // console.log(this.objScript);
      if (!(this.objScript && this.objScript["code"])) return "";
      let result = {};
      let strCode = this.objScript["code"] || "";
      let objLanguage = core.getLanguage(this.objScript["lang"]);
      // console.log(this.objScript);
      // console.log(objLanguage);
      let strLanguage = objLanguage && objLanguage.name;

      if (!strLanguage) {
        result = core.highlightAuto(strCode);
        if (result.language) {
          console.warn(
            `The language "${strLanguage}" you specified could not be found.`
          );
          return strCode;
        }
      } else {
        if (strLanguage == "Plain text") return strCode;
        result = core.highlight(strCode, {
          language: strLanguage,
          // ignoreIllegals: this.ignoreIllegals
        });
      }
      this.changeLang(result.language);
      return result.value;
    },
  },
  methods: {
    changeLang(strLang) {
      if (strLang) {
        this.strDetectLang = strLang;
      } else {
        this.boolUnkonwLang = true;
      }
      // console.log(strLang);
    },
  },
};
</script>
